import { normalizeApiErrorMessages } from "./normalizeApiErrorMessages";
import { showAppErrorToast, showAppErrorToasts } from "./appErrorBridge";

const DEFAULT_FALLBACK = "We encountered an error. Please try again.";

/**
 * Shows Spectrum error toast(s) from a partner API error payload (same shapes as {@link normalizeApiErrorMessages}).
 * Use from button/submit callbacks when `isError`, non-2xx responses, or `errors[]` from the server.
 *
 * @param {object} [payload] - API body or merged axios error shape
 * @param {string} [fallbackMessage] - Used when no messages could be normalized
 */
export function toastPartnerApiFailure(payload, fallbackMessage = DEFAULT_FALLBACK) {
  const msgs = normalizeApiErrorMessages(payload || {});
  const fb = fallbackMessage || DEFAULT_FALLBACK;
  if (msgs.length === 0) {
    showAppErrorToast(fb);
    return;
  }
  if (msgs.length === 1) {
    showAppErrorToast(msgs[0]);
    return;
  }
  showAppErrorToasts(msgs);
}
